/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { checkValue } from 'src/components/common/helper';
import { ModuleProps } from 'src/utils/module-util';
import { DynamicEntryFormComponent } from 'src/components/common/modules/v1/dynamic-entry-form/code-split/dynamic-entry-form-component';
import CompetitionEntry from 'src/components/common/modules/v1/competition-entry';
import { getStore } from 'src/utils/store-utils';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import V3CompetitionEntryForm from '../../v3/meso/v3-competition-entry-form';

const DynamicEntryFormModuleOld = (props: ModuleProps) => {
  const { data, id } = props;
  const storeData = getStore();
  const { primaryColour, secondaryColour, mainUrl } = storeData;
  const entryFormProps = {
    module: data.module,
    data,
    uniquekey:
      'uniquekey' in data && checkValue(data?.uniquekey) ? data?.uniquekey : `pageContent-rand-${Math.random()}`,
    primaryColour: checkValue(primaryColour) ? primaryColour : '',
    secondaryColour: checkValue(secondaryColour) ? secondaryColour : '',
    campaign_name: checkValue(mainUrl) ? mainUrl : '',
    id,
  };

  return <DynamicEntryFormComponent {...entryFormProps} />;
};

const DynamicEntryFormModule = (props: ModuleProps) => {  
  const componentLayoutType: ComponentLayoutType<any> = {
    moduleName: 'CompetitionEntry',
    data: props,
  };

  const { data } = props;
  const hideModule = data?.hideModule; 

  return checkValue(hideModule) && hideModule === 'True' ? null : <CompetitionEntry {...componentLayoutType} />;
};

export { DynamicEntryFormModuleOld, DynamicEntryFormModule };
